import React from "react";
import { Trans } from "@lingui/react/macro";

const PopupManager = ({
  popupDetails,
  setPopupDetails,
  validationErrors,
  handleCreateProject,
  handleTimingAction,
  closePopup,
  isCreatingProject,
  setIsCreatingProject,
}) => {
  if (!popupDetails.action) return null; // Don't render if no popup is active

  return (
    <div className="popupOverlay">
      <div className="popupContent">
        {/* Start Time Popup */}
        {popupDetails.action === "start_time" && (
          <p>
            <Trans>Are you sure you want to log start time for</Trans>{" "}
            <strong>{popupDetails.data.customer_name}</strong>?
          </p>
        )}

        {/* End Time Popup */}
        {popupDetails.action === "end_time" && (
          <p>
            <Trans>Are you sure you want to log end time for</Trans>{" "}
            <strong>{popupDetails.data.customer_name}</strong>?
          </p>
        )}

        {/* Create Project Popup */}
        {popupDetails.action === "create_project" && (
          <div>
            <h2>
              <Trans>Create New Project</Trans>
            </h2>
            <form>
              <label htmlFor="customerName">
                <Trans>Name of the customer:</Trans>
              </label>
              <input
                id="customerName"
                type="text"
                value={popupDetails.data.customer_name}
                onChange={(e) =>
                  setPopupDetails((prev) => ({
                    ...prev,
                    data: { ...prev.data, customer_name: e.target.value },
                  }))
                }
                required
              />
              {validationErrors.customer_name && (
                <p className="error">{validationErrors.customer_name}</p>
              )}

              <label htmlFor="description">
                <Trans>Description:</Trans>
              </label>
              <textarea
                id="description"
                value={popupDetails.data.description}
                onChange={(e) =>
                  setPopupDetails((prev) => ({
                    ...prev,
                    data: { ...prev.data, description: e.target.value },
                  }))
                }
              />
              {validationErrors.description && (
                <p className="error">{validationErrors.description}</p>
              )}

              <label htmlFor="street">
                <Trans>Street:</Trans>
              </label>
              <input
                id="street"
                type="text"
                value={popupDetails.data.street}
                onChange={(e) =>
                  setPopupDetails((prev) => ({
                    ...prev,
                    data: { ...prev.data, street: e.target.value },
                  }))
                }
                required
              />
              {validationErrors.street && (
                <p className="error">{validationErrors.street}</p>
              )}

              <label htmlFor="house_number">
                <Trans>House number:</Trans>
              </label>
              <input
                id="house_number"
                type="text"
                value={popupDetails.data.house_number}
                onChange={(e) =>
                  setPopupDetails((prev) => ({
                    ...prev,
                    data: { ...prev.data, house_number: e.target.value },
                  }))
                }
              />
              {validationErrors.house_number && (
                <p className="error">{validationErrors.house_number}</p>
              )}

              <label htmlFor="postal_number">
                <Trans>Postal Number:</Trans>
              </label>
              <input
                id="postal_number"
                type="text"
                value={popupDetails.data.postal_number}
                onChange={(e) =>
                  setPopupDetails((prev) => ({
                    ...prev,
                    data: { ...prev.data, postal_number: e.target.value },
                  }))
                }
                required
              />
              {validationErrors.postal_number && (
                <p className="error">{validationErrors.postal_number}</p>
              )}

              <label htmlFor="town">
                <Trans>Town:</Trans>
              </label>
              <input
                id="town"
                type="text"
                value={popupDetails.data.town}
                onChange={(e) =>
                  setPopupDetails((prev) => ({
                    ...prev,
                    data: { ...prev.data, town: e.target.value },
                  }))
                }
              />
              {validationErrors.town && (
                <p className="error">{validationErrors.town}</p>
              )}
            </form>
          </div>
        )}

        {/* Popup Action Buttons */}
        <div className="popupActions">
          {(popupDetails.action === "start_time" ||
            popupDetails.action === "end_time") && (
            <>
              <button
                className="confirmButton"
                onClick={() =>
                  handleTimingAction(popupDetails.action, popupDetails.data)
                }
              >
                <Trans>Yes</Trans>
              </button>
              <button className="cancelButton" onClick={closePopup}>
                <Trans>No</Trans>
              </button>
            </>
          )}
          {popupDetails.action === "create_project" && (
            <>
              <button
                className={`confirmButton ${
                  isCreatingProject ? "disabled" : ""
                }`}
                onClick={handleCreateProject}
                disabled={isCreatingProject}
              >
                {isCreatingProject ? (
                  <Trans>Creating...</Trans>
                ) : (
                  <Trans>Create</Trans>
                )}
              </button>
              <button
                className={`cancelButton ${
                  isCreatingProject ? "disabled" : ""
                }`}
                onClick={closePopup}
                disabled={isCreatingProject}
              >
                <Trans>Cancel</Trans>
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default PopupManager;
